export const EAC_LIGHT_THEME_PATHS = ["/eac/factor", "/eac/energyEntity", "/eac/energyCoefficient"];

let transitionTimer = null;

const withoutThemeTransition = (callback) => {
  document.documentElement.classList.add("theme-switching");
  callback();

  window.clearTimeout(transitionTimer);
  transitionTimer = window.setTimeout(() => {
    document.documentElement.classList.remove("theme-switching");
  }, 80);
};

export const resolveRouteTheme = (to) => {
  if (EAC_LIGHT_THEME_PATHS.some((path) => to.path === path || to.path.startsWith(`${path}/`))) {
    return "";
  }

  return to.meta?.theme || "";
};

export const applyThemeClass = (theme) => {
  const classList = theme.split(/\s+/).filter(Boolean);
  const isDark = classList.includes("dark");
  const currentIsDark =
    document.documentElement.classList.contains("dark") ||
    document.body.classList.contains("dark") ||
    document.body.classList.contains("theme-dark");

  const apply = () => {
    document.body.className = theme;
    document.documentElement.classList.toggle("dark", isDark);
  };

  if (currentIsDark === isDark) {
    apply();
    return;
  }

  withoutThemeTransition(apply);
};

export const applyThemeName = (themeName) => {
  applyThemeClass(themeName === "dark" ? "dark theme-dark" : "");
};
